export enum TestTypesActions {
  Reset = "reset",
  FetchTypes = "fetchTypes",
  FetchType = "fetchType",
  AddType = "addType",
  EditType = "editType",
}
